import GlodEntranceView from './goldentrance_view';
import HallServerNotify from '../../../server/hallnotify/hall_serve_notify';
import ModuleBase, { moduleInit, implementFunction, bindButtonClickEvent } from '../../../../../framework/core/mvvm/module_base';
import AppData from '../../../../public/const/app_data';
import ModelData, { IUserData } from '../../../../public/model_data';
import ModuleManager from '../../../../../framework/core/module_manager';
import { ProtoHallServerNotify } from '../../../server/hallnotify/proto_hall_gameserver_notify';
import Record from '../../record/record';
import GoldRoomItem from './gold_room_item';
import SceneManager from '../../../../../manager/scene_manager';
import NotifyServer from '../../../server/notify/notify_server';
import { GameManager } from '../../../../../manager/game_manager';
import Rule from '../../rule/rule';
import { NotifyData } from '../../../../public/notify_data';
import { IUserCurrencyData } from '../../../../../manager/user_manager';

import Shop from '../../shop/shop';
import { joinUtil } from '../../../../public/join_util';

const { ccclass } = cc._decorator;


@ccclass
@moduleInit("GoldEntranceModule")
export default class GoldEntranceModule extends ModuleBase<GlodEntranceView, null> {

    //map< accountType * 100 + roomType,map<roomId,roomData> >
    private roomMap : Map<number, Map<number,ProtoHallServerNotify.IRoomData> >  = new Map();
    
    //< accountType * 100 + goldType,roomIndex>
    private roomTypeMap : Map<number,number> = new Map();
    //<roomIndex,accountType>
    private roomIndexMap : Map<number,number> = new Map(); 

    //<roomIndex,data>
    private roomDataMap : Map<number,any> = new Map();

    static http_session_list = {};

    private pushAllData = true;
    
    /**
     * 大厅前置动画
     */
    private preTweenOver : boolean;

    private tweenOver : boolean;

    private allConnected : boolean;


    //当前场次信息
    private selectGoldInfo : any;

    static defaultSelect = -1;
    private chipCach: number = 0;    

    private currentGame ;

    constructor() {
        super();
        this.modelType = null;
        this.windowPrefabResPath = "package/hall/module/goldentrance/hall_goldentrance";
        this.viewType = GlodEntranceView;
        // cc.sys.localStorage.setItem("LATELY_GAME", AppData.gameName)
    }

    onInit(intentData: any) {
        //this.roomList = {};
        //this.refreshSession();
        //this.connectServer();
        
        this.preTweenOver = false;
        this.tweenOver = false;

        super.onInit(intentData);

        this.eventBind('on_goldentrance_toggle', this.on_goldentrance_toggle)

        //LoaclStorage.setItem("Module_xx_GoldEntranceModule|" + this.role_id, AppData.gameName);
    }

    private on_goldentrance_toggle(togIndex){

        let accountType = this.roomIndexMap.get(togIndex); 

        this.selectGoldInfo = this.roomDataMap.get(togIndex);

        this.view.updateCoinIcon(accountType);
    }

    onEnable(){

        //this.refreshTitle()
    }

    onShow(intentData) {
        let self = this
        //self.view.resetSelectToggle();
        self.view.initializationTitleSetting();
        self.getUserData(ModelData.instance.roleData.id, (data: IUserData) => {
            self.view.setInfo(data)
        })

        SceneManager.lastEntranceOpenModuleName = "GoldEntranceModule"
        // ModuleManager.instance.setModuleActive("HallBase", true)
  
        if (intentData == "fromTable") {
            cc.log("intentData == fromTable");
            // let hallbase: HallBase = ModuleManager.instance.getModule("HallBase")
            // if (hallbase) {
            //     hallbase.isGoldEntranceShow()
            // }
            this.tweenOver = true;
            this.tweenToOver();
        }
        else if(intentData == "HallShowGoldEntrance") {
            cc.log(" intentData " , intentData);

            this.node.active = false;
            this.preTweenOver  = false;
            this.tweenOver = false;

            if (this.currentGame != AppData.gameName) {
                this.roomMap.clear();   
                this.view.clearitem();   
                this.view.clearTittle(); 
                this.view.reset();     
                this.currentGame = AppData.gameName;        
            }

            
        }else if(intentData == "ShowMango"){

            //芒果默认1
            this.view.checkTog(1);

            this.node.active = false;
            this.preTweenOver  = false;
            this.tweenOver = false;
        }

        this.showLayerTop()
        if (!NotifyServer.instance.netClient.netState) {
            NotifyServer.instance.connectServer(GameManager.notifyServer + ModelData.instance.userToken)
        }
        NotifyData.instance.changePlayerPos('hall', true)   
        
        this.refreshSession(true);
    }
    
    @implementFunction('onSelfCurrencyDataUpdate')
    protected on_selfCurrencyDataUpdate(data: IUserCurrencyData) {
        this.view.setGold(data)
        this.chipCach = data.chip;
    }

    tweenShowView(aniName) {
        this.setActive()
        this.tweenToOver();

        let self = this;
        this.view.tweenTo(aniName, false, ()=>{
            self.tweenOver = true;         
            
            if (self.allConnected) {

                let maxValue = this.getAllowValue();
                if(self.chipCach < maxValue){                    
                    //不够就弹充值
                    joinUtil.showRecharge(this,true,maxValue);
                }    
            }
            
        });
    }

    private getAllowValue(){

        if (!this.selectGoldInfo) {
            return 0;
        }

        let playRule = JSON.parse(this.selectGoldInfo.playRule);
        let minBet = playRule.game_BetArr && playRule.game_BetArr.length > 0? playRule.game_BetArr[0] : 0;
        
        let allowNum = playRule.pub_AllowNum? playRule.pub_AllowNum : 0;

        return Math.max(minBet,allowNum);
    }

    protected onButtonClickName(name: string, customEventData, item: cc.Node) {
        switch (name) {
            case "BackBtn":
                let self = this
                SceneManager.lastEntranceOpenModuleName = ""
                HallServerNotify.instance.close()
                SceneManager.showHall("OpenFromGoldEntranceModule", () => {
                    self.hide()
                })
                break;
            case "RecordBtn":
                ModuleManager.instance.showModule(Record, "record")
                break;
            case "EnterBtn":{

                if (!this.selectGoldInfo) {
                    return;
                }
                let roomData = null
                roomData = item.parent.getComponent(GoldRoomItem).data

                let playRule = JSON.parse(this.selectGoldInfo.playRule);
                joinUtil.joinMultiple(playRule,this.chipCach,roomData.roomId);
                
                // let maxValue = this.getAllowValue();

                // if(this.chipCach < maxValue){
                    
                //     let text = LanguageManager.t("join_coin_no_enough_tip").format(GameUtil.currencyFormat(maxValue));                    
                //     ModuleManager.instance.toast(text);
                // }else{

                //     let roomData = null
                //     roomData = item.parent.getComponent(GoldRoomItem).data

                //     if (roomData.apiData) {
                //         HallServer.instance.joinRoom(roomData.roomId, () => {

                //         }, null, 1, roomData.gameGoldId, 1);
                //     } else {
                //         HallServer.instance.joinRoom(roomData.roomId, () => {});
                //     }
                //     LoaclStorage.setItem("Module_xx_GoldEntranceModule_select", this.view.selectToggle);
                // }                                     
            }                                
                break;
            case "HelpBtn":
                ModuleManager.instance.showModule(Rule, {isSys:false})
                break;
            case "SpriteAvatar":
                break;
            case "Button_Reconnect":                                
                HallServerNotify.instance.disconnect();
                break;   
            default:
                break;
        }
    }


    connectServer() {     

        let self = this;

        HallServerNotify.instance.connectServer()//("ws://116.62.41.223:3507")

        HallServerNotify.instance.onReconnectServerFail = () => {
            //cc.log("xxxxx:this.getGameGolds");
            cc.log("xxxxx:this.getGameGolds 连接失败");
            self.refreshSession(true);            
        }

        //登入成功 或断线重连 清除场次数据
        HallServerNotify.instance.onNotifyLogin = (data,isReconnect) => {
            
            self.allConnected = true;

            if (isReconnect) {
                //如果断线重连 才需要删除..
                self.roomMap.clear();
                self.view.clearitem();
                self.view.reset();                

            }else if(self.tweenOver){

                let maxValue = this.getAllowValue();
                if(self.chipCach < maxValue){                    
                    //不够就弹充值
                    joinUtil.showRecharge(this,true,maxValue);
                }
            }
        }

        HallServerNotify.instance.onEnterGameHall = () => {
            

        }

        HallServerNotify.instance.onNotifyHallData = (data: ProtoHallServerNotify.INotifyHallData) => {
        
            //每进入选场连接成功后 将不存在的房间给从缓存中剔除
            if (this.pushAllData) {
             
                self.roomMap.forEach((sceneMap,roomType)=>{
                                 
                    let sceneIndex = self.roomTypeMap.get(roomType);
                    sceneMap.forEach((roomData,roomId)=>{
    
                        let findRoom = false;
                        for (let index = 0; index < data.room.length; index++) {
                            const roomInfo = data.room[index];                                     
                            findRoom = roomData.roomId == roomInfo.roomId;
                            if (findRoom) break;                                                            
                        }                    
                        if (!findRoom) {                        
                            sceneMap.delete(roomId);
                            cc.log(" deleteItem  roomMap :" , self.roomMap);  
                            self.view.deleteItem(sceneIndex,roomData); 
                            self.roomMap.set(roomType,sceneMap);
                        }
                    });                     
                   
                })

                this.pushAllData = false;
            }                                 
            //首次连接成功与与运营服的场次进行筛选          
            if (self.roomMap.size == 0) {
                                                      
                self.view.clearitem();
                self.view.reset();

                for (let index = 0; index < data.room.length; index++) {
                    const roomData = data.room[index];
                    
                    if (!roomData.curPlayrule) {
                        continue;
                    }
                    let extJson = JSON.parse(roomData.extJson);     
                    
                    let actType = extJson.accountType;

                    let roomType = this.getRoomType(actType,Number(roomData.roomType));
                    if (!this.checkRoomType(roomType) ) {
                        //运营系统已经没有该场次了
                        continue;
                    }
                    
                    if (roomData.closed) {                                                  
                        continue;
                    }
                
                    let sceneMap = self.roomMap.get(roomType);
                    if (!sceneMap) {
                        sceneMap = new Map();
                    }                                            
                    self.roomMap.set(roomType,sceneMap.set(roomData.roomId,roomData));
                }

                cc.log("刷新数据:",self.roomMap);
                self.refreshShow(self.roomMap)                  
            
            }else{
                
                //推送一条信息
                let roomData = data.room.length > 0? data.room[0] : null;
                if (roomData) {
                    
                    let extJson = JSON.parse(roomData.extJson);
                    let actType = extJson.accountType;

                    let roomType = this.getRoomType(actType,Number(roomData.roomType));
                    let sceneMap = self.roomMap.get(roomType);   
                    let sceneIndex = self.roomTypeMap.get(roomType);
                                
                    if (!this.checkRoomType(roomType)) {
                        //运营系统已经没有该场次了                 
                        return;
                    }
                    if (!sceneMap) {
                        sceneMap = new Map();
                        this.view.addItem(sceneIndex,roomData);
                        sceneMap.set(roomData.roomId,roomData);    
                    }
                    else {
                        
                        if (roomData.closed) {
                            if (sceneMap.has(roomData.roomId)) {
                                //删除    
                                cc.log(" deleteItem  roomMap :" , self.roomMap);  
                                this.view.deleteItem(sceneIndex,roomData);  
                                sceneMap.delete(roomData.roomId);        
                            }
                        }else{
    
                            if (sceneMap.has(roomData.roomId)) {
                                //更新
                                cc.log(" refreshItem  roomMap :" , self.roomMap);
                                this.view.refreshItem(roomData);
                                sceneMap.set(roomData.roomId,roomData);
                            }else{    
                                 //增加一个房间
                                cc.log(" addItem  roomMap :" , self.roomMap);
                                this.view.addItem(sceneIndex,roomData);
                                sceneMap.set(roomData.roomId,roomData);                                                                
                            }
                        }                                               
                    }    
                    self.roomMap.set(roomType,sceneMap);                                                            
                }
            }               
        }
        HallServerNotify.instance.onNotifyRoomTypeData = (data: ProtoHallServerNotify.NotifyRoomTypeData) => {

            //var temp:{[key:string]:number} ={}
            //cc.log("111111111111新的彩池数据:",data);
            var jackPotData: { [key: string]: { [key: string]: number } } = {};
            for (let i = 0; i < data.roomType.length; i++) {
                //cc.log("111111111111新的彩池数据:",data.roomType[i]);
                //cc.log("jackPotData[data.roomType[i].roomType]jackpot",jackPotData[data.roomType[i].roomType]);
                jackPotData[data.roomType[i].roomType] = {};
                if (data.roomType[i].jackpot) {
                    jackPotData[data.roomType[i].roomType]["jackpot"] = data.roomType[i].jackpot;
                }
                else {
                    jackPotData[data.roomType[i].roomType]["jackpot"] = 0;
                }
                if (data.roomType[i].extJson) {
                    var extJson = JSON.parse(data.roomType[i].extJson);
                    //cc.log("extJson:",extJson);
                    if (extJson.minJoinCoin) {
                        jackPotData[data.roomType[i].roomType]["minJoinCoin"] = Number(extJson.minJoinCoin);
                    }
                    else {
                        jackPotData[data.roomType[i].roomType]["minJoinCoin"] = 0;
                    }
                }
                else {
                    jackPotData[data.roomType[i].roomType]["minJoinCoin"] = 0;

                }
            }
            //cc.log("jackPotData:",jackPotData);
            this.refreshJackPot(jackPotData);
        }

    }

    @bindButtonClickEvent("ButtonChip")
    onBUttonCurrencyChip() {
        ModuleManager.instance.showModule<Shop>(Shop, {tag: "tag_coin"})
    }

    getRoomType(actType:number,roomType:number){

        return actType * 100 + roomType;
    }

    checkRoomType(findType : number) : boolean{

        return this.roomTypeMap.has(findType);
    }


    refreshShow(roomMap : Map<number, Map<number,ProtoHallServerNotify.IRoomData> >, useAPIData = false) {
        //cc.log('refreshShow:',GoldEntranceModule.tweenOver);
        if (this.preTweenOver) {
            this.view.updateShow(roomMap, useAPIData)
        }
    }
    //刷新彩池
    refreshJackPot(roomtypeData) {
        let self = this;
        //cc.log("roomtypeData:",roomtypeData);
        self.view.updateJackPot(roomtypeData)

    }

    getCurrentSessionData() : any{

        return GoldEntranceModule.http_session_list[AppData.gameName];
    }

    private checkScene(){
        //渠道不控制游戏场次
        return true;
    }


    refreshSession(connectServer? : boolean) {

        this.allConnected = false;

        let self = this
        
        this.refreshTitle(null);

        let requestData: IHttpRequestData = {
            baseUrl: "gold/getGameGolds?",
            encrypt:true
        }
        
        this.apiHttpGet(requestData, (respone) => {
            respone.data.forEach( (data)=>{
                if (data.gameId != AppData.gameName) {
                    //表示不是当前的场次,网络延迟所致?
                    return;      
                }
            });

            joinUtil.updateRoomData(respone.data);

            GoldEntranceModule.http_session_list[AppData.gameName] = respone.data;

            self.refreshTitle(respone.data);

            self.view.syncSceneMap(self.roomTypeMap);

            if (connectServer) {             
                self.connectServer();    
            }    
        }, function (err) {
            cc.log(err)
        })
    }

    refreshTitle(respone_data? : any[]){
        let self = this;
        if (!respone_data) {
            
            respone_data = this.getCurrentSessionData();
        }

        if (!respone_data) {
            
            return;
        }
        var list = []      
        
        //先将没有的场次剔除掉    
        this.roomTypeMap.forEach((value,key)=>{

            let exist = false;

            for (let index = 0; index < respone_data.length; index++) {
                let actType = respone_data[index].accountType;
                let roomtype = this.getRoomType(actType,respone_data[index].goldType);
                exist = key == roomtype;     
                if (exist) break;      
            }
            
            if (!exist) {                                
                self.view.clearSceneItem(key);
                self.roomMap.delete(key);                
            }
           
        });

        this.roomTypeMap.clear();
        this.roomIndexMap.clear();
        this.roomDataMap.clear();

        //根据渠道过滤场次
        respone_data = respone_data.filter( (data:any)=>{
            return this.checkScene();
        } );
        
        for (let index = 0; index < respone_data.length; index++) {
            let actType = respone_data[index].accountType;

            let rule = JSON.parse(respone_data[index].playRule);
            //let roomType = respone_data[index].goldType;
            let roomType = this.getRoomType(actType,respone_data[index].goldType);

            this.roomTypeMap.set(roomType,index);
            this.roomIndexMap.set(index,actType);
            this.roomDataMap.set(index,respone_data[index]);

            //这里清理一下            
            if (index > 0) {
                list.push(rule.pub_AllowNum);
            }     
        
        }          


        cc.log("this.roomTypeMap.size:",this.roomTypeMap.size);
        if (this.roomTypeMap.size < 2) {
            
            if (this.roomTypeMap.size == 0) {
                this.view.clearitem();
            }
            // for (let index = 0; index < self.view.toggleList.length; index++) {
            //     self.view.toggleList[index].node.active = false;
            // }
            // this.view.toggleBg.active = false;
            this.view.setSelectToggle(this.roomTypeMap.size-1, this.roomTypeMap.size);

            let actType = this.roomIndexMap.get(0);
            this.view.updateCoinIcon(actType);
            
            GoldEntranceModule.defaultSelect = this.roomTypeMap.size-1;
            //this.view.checkSelectToggle(this.roomTypeMap.size-1);
            this.view.showSpecialBg(true);   

            this.selectGoldInfo = this.roomDataMap.get(0);
        }                               
        else{
            this.view.showSpecialBg(false);
            // for (let x = 0; x < this.roomTypeMap.size; x++) {
            //     if(this.view.toggleList[x])
            //     {
            //         this.view.toggleList[x].node.active = true;
            //     }
            // }

            let toggleSelect = this.view.toggleSelect;
            if (toggleSelect == -1) {
                toggleSelect = this.chipCach > 0 ? this.filtRaterecom(list) : 0;
            }   
            //GoldEntranceModule.defaultSelect = defaultToggle;
            this.view.setSelectToggle(toggleSelect, this.roomTypeMap.size);

            let actType = this.roomIndexMap.get(toggleSelect);
            this.view.updateCoinIcon(actType);

            //this.view.checkSelectToggle(defaultToggle);
            // var count = this.view.toggleList.length;
            // var len = count - respone_data.length;
            // var x_size = 1594;
            // var x_positon = 0;
            // var x_positon2 = 1;
            // //cc.log("respone.data.length,len:",respone.data.length,len);
            // if (len > 0) {
            //     for (let index = 0; index < len; index++) {
            //         //self.view.toggleList[index].node.active = true;
            //         //cc.log("count - index - 1:",count - index - 1);
            //         this.view.toggleList[count - index - 1].node.active = false;
            //     }

            //     switch (len) {
            //         case 1:
            //             x_positon = 0.7;
            //             x_size = 1261.9;
            //             x_positon2 = 160.7
            //             break;
            //         case 2:
            //             x_positon = -0.3;
            //             x_size = 951;
            //             x_positon2 = 315.86;
            //             break;
            //         case 3:
            //             x_positon = -53.4;
            //             x_size = 632;
            //             x_positon2 = 418.8
            //             break;
            //     }
            // }
            // this.view.setToggleBgSize(x_size, x_positon, x_positon2);
        }                
    }
    

    fromTable() {
        // self.view.checkSelectToggle(GoldEntranceModule.defaultSelect);
        // GoldEntranceModule.tweenOver = true;
        this.node.active = true
        this.view.top.active = true
        // if (this.roomList) {
        //     this.scheduleOnce(function () {
        //         self.refreshShow(this.roomList, false);
        //     }, 2)

        // }
    }
    // tweenAnimation(data: any, inverted: any) {
    //     cc.log("tweenAnimation动画");
    //     this.setActive()
    //     this.tweenOver = false;
    //     this.view.tweenTo(data, inverted, this.tweenToOver.bind);
    // }
    tweenToOver() {
        let self = this;
        this.preTweenOver = true;
        this.node.active = true
        this.view.top.active = true
        this.refreshShow(self.roomMap, false);
        this.view.rightNode.active = true
    }

    filtRaterecom(list: any) {
        var temp = 0;
        var recommendIndex = -1;
        list.forEach((element, index) => {
            if (this.chipCach >= element && temp <= element) {
                temp = element
                recommendIndex = index;
            }
        });
        //cc.log("最适合的场次限额:",this.chipCach,recommendIndex)
        return recommendIndex + 1;
    }
    turnRoomType(goldtype: any) {
        var temp = Number(goldtype);
        var index = 0;
        if (temp == 10) {
            index = 0;
        }
        else {
            index = temp;
        }
        return index;
    }
    onHide() {
        HallServerNotify.instance.exit()
        
        this.pushAllData = true;
        //this.roomMap.clear();        
    }


    onDestroy() {
        HallServerNotify.instance.exit()
        //this.roomMap.clear();
    }



}
